'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactScroll = require('react-scroll');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('../../components');
var _containers = require('../../containers');

var _packagesData = require('../../packagesData');
var _paymentCalculation = require('../../helpers/paymentCalculation');

var _PackagesBlock = require('./PackagesBlock.scss');var styles = _interopRequireWildcard(_PackagesBlock);
var _couponsConfig = require('../DiscountCouponContainer/couponsConfig');
var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _clearNumber = require('../../helpers/clearNumber');var _clearNumber2 = _interopRequireDefault(_clearNumber);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Helpers
// Styles
var PackagesBlock = function (_Component) {_inherits(PackagesBlock, _Component);function PackagesBlock(props) {_classCallCheck(this, PackagesBlock);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.


























    handleCloseTooltip = function () {return _this.setState({ hideActiveTooltip: true });};_this.

    handleMouseEnter = function (id) {
      clearTimeout(_this.leaveTimeout);
      _this.enterTimeout = setTimeout(function () {return _this.setState({ packageIdForTooltip: id });}, 350);
    };_this.

    handleMouseLeave = function () {
      clearTimeout(_this.enterTimeout);
      _this.leaveTimeout = setTimeout(function () {return _this.setState({ packageIdForTooltip: null });}, 350);
    };_this.

    checkIfNeedShowTooltip = function (id) {var _this$state =
      _this.state,packageIdForTooltip = _this$state.packageIdForTooltip,hideActiveTooltip = _this$state.hideActiveTooltip;var
      selectedPackage = _this.props.selectedPackage;

      return packageIdForTooltip !== null ?
      packageIdForTooltip === id :
      !hideActiveTooltip && selectedPackage.checked === id;
    };_this.

    renderPackage = function (item) {return (
        _react2.default.createElement(_components.PackageItem, {
          key: item.id,
          'package': item,
          periods: _this.state.periods,
          translate: _this.props.translate,
          locale: _this.props.locale,
          isMobile: _this.props.isMobile,
          isAgent: _this.props.isAgent,
          changeSelectedPayment: _this.props.changeSelectedPayment,
          selectedPackage: _this.props.selectedPackage,
          hasPhotos: _this.props.hasPhotos,
          handleMouseEnter: _this.handleMouseEnter,
          handleMouseLeave: _this.handleMouseLeave,
          showTooltip: _this.checkIfNeedShowTooltip(item.id),
          handleCloseTooltip: _this.handleCloseTooltip }));};_this.



    renderPriceItem = function (label, data, isBold) {var _cx;return (
        _react2.default.createElement('div', { className: styles.priceItem },
          _react2.default.createElement('span', null, '' + _this.props.translate(label), '\xA0'),
          _react2.default.createElement('span', { className: (0, _classnames2.default)((_cx = {}, _cx[styles.boldText] = isBold, _cx)) }, '\u200E', data)));};_this.



    renderTotalPriceBlock = function () {var _cx2;
      var couponType = (0, _get2.default)(_this.props, 'discountCoupon.type');
      var amount = (0, _paymentCalculation.calculatePaymentAmount)(_this.props.selectedPackage, _this.state.packages);
      var packagePriceLabel = couponType ? 'package' : 'total';
      var packagePrice = _this.renderPriceItem(packagePriceLabel, '\u20AA ' + amount, !couponType);
      var bonus = void 0;
      var totalPrice = void 0;

      if (couponType) {
        var clearedAmount = (0, _clearNumber2.default)(amount);
        var bonusAmount = (0, _paymentCalculation.getCouponBonus)(clearedAmount, couponType, _this.props.selectedPackage, _this.state.packages);
        var totalAmount = (0, _beautifyNumber2.default)(clearedAmount - bonusAmount);

        bonus = _this.renderPriceItem('benefit', '- \u20AA ' + bonusAmount);
        totalPrice = _this.renderPriceItem('total', '\u20AA ' + totalAmount, true);
      }

      return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.total, (_cx2 = {}, _cx2[styles.couponBonus] = !!couponType, _cx2)) },
          _react2.default.createElement('div', null,
            packagePrice,
            bonus,
            totalPrice)));



    };_this.state = { packages: (0, _packagesData.getPackages)(props.isAgent), periods: (0, _packagesData.getPackagePeriods)(props.isAgent), packageIdForTooltip: null, hideActiveTooltip: false };return _this;}PackagesBlock.prototype.componentDidMount = function componentDidMount() {if (this.props.needsScrollDown) {_reactScroll.scroller.scrollTo('packages', { duration: 500, smooth: true });}};PackagesBlock.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {var isAgent = _ref.isAgent;if (isAgent !== this.props.isAgent) {this.setState({ packages: (0, _packagesData.getPackages)(isAgent), periods: (0, _packagesData.getPackagePeriods)(isAgent) });}};PackagesBlock.prototype.

  render = function render() {
    return (
      _react2.default.createElement(_reactScroll.Element, { name: 'packages', className: styles.pricingWrapper },
        _react2.default.createElement(_components.OMTitle, { title: this.props.translate(this.props.isAgent ? 'selectPackage' : 'adType'), className: 'publishTitle' }),
        this.state.packages.map(this.renderPackage),
        this.props.isAgent &&
        _react2.default.createElement(_components.CustomPackage, {
          translate: this.props.translate,
          locale: this.props.locale,
          saveDataToStorage: this.props.saveDataToStorage }),


        _react2.default.createElement('span', { className: styles.smallTitle }, this.props.translate('withoutTax')),
        this.renderTotalPriceBlock(),
        _react2.default.createElement('div', { className: styles.couponWrapper },
          _react2.default.createElement(_containers.DiscountCouponContainer, {
            updateCoupon: this.props.updateCoupon }))));




  };return PackagesBlock;}(_react.Component);exports.default = PackagesBlock;


PackagesBlock.propTypes = {
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  saveDataToStorage: _propTypes2.default.func.isRequired,
  isMobile: _propTypes2.default.bool,
  selectedPackage: _propTypes2.default.object,
  discountCoupon: _propTypes2.default.object,
  changeSelectedPayment: _propTypes2.default.func.isRequired,
  needsScrollDown: _propTypes2.default.bool.isRequired,
  isAgent: _propTypes2.default.bool.isRequired,
  updateCoupon: _propTypes2.default.func,
  hasPhotos: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PackagesBlock/PackagesBlock.js
// module id = 2980
// module chunks = 0